import React, {Component} from 'react';

import '../maps/leaflet/leaflet.css';
import L from 'leaflet';
import {siteGeoCode, siteGeoLocation} from '../database/apiv2SiteAccessor';
import {ContactStyle, ContactAge} from '../Decorators/Checkmarks'
import LeafletIcons from '../maps/LeafletIcons';
import { PanelDots } from "../Utils/PanelDots.js"

import './mappane.css';
import '../maps/leaflet_intro.css';

export default class MapPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideIndex: 0,
    }
    this.slideMax = 1
    this.mymap = null;
    this.site = null;
    this.mapIcons = null;
  }

  async componentDidMount() { 
    this.site = this.props.getActiveSite()
    this.initMap()
  }
  componentDidUpdate(prevProps) {
    if (this.state.slideIndex === 0 && this.mymap === null)
      this.initMap()
    if (this.props.streetView)
      this.slideMax =2
  }
  initMap () {
    const coords = siteGeoCode(this.site) ?? [39.083209663, -94.58124886];
    const mymap = L.map('leafletMap').setView(coords, 16);
    const attrib = 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';
    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
          attribution: attrib,
          maxZoom: 18,
          id: 'mapbox/streets-v11',
          //id: 'mapbox/satellite-v9',
          //id: 'mapbox/satellite-streets-v12',
          tileSize: 512,
          zoomOffset: -1,
          accessToken: process.env.REACT_APP_MAPBOX
          }).addTo(mymap);
    this.mapIcons = new LeafletIcons({data: mymap, ...this.props});
    this.addMapMarker (this.site, mymap);
    this.mymap = mymap;
  }
  async addMapMarker(site, mymap) {
    const coords = siteGeoCode(site);
    const style = ContactStyle(ContactAge({'site' : site}));
    const pin = site.pinStyle ?? 0;
    if (coords) {
      L.marker(coords, {icon: this.mapIcons.fromAttributes(style,pin)}).addTo(mymap);
    }
    else {
      const loc = siteGeoLocation(site);
      if (loc) {
        L.marker(loc, {icon: this.mapIcons.fromAttributes(style,pin)}).addTo(mymap);
      }
    }
  }
  slide = () => {
    const newSlide = this.state.slideIndex === 0 && this.state.slideIndex+1 < this.slideMax ? 1 : 0
    if (newSlide > 0 && this.mymap) {
      this.mymap.remove()
      this.mymap = null
    }
    this.setState({slideIndex: newSlide})
  }
  slidePanel () {
    switch (this.state.slideIndex) {
      default:
      case 0:
        return <div className="map-pane" id="leafletMap" />
      case 1:
        return (<div className="street-pane" id='street'>
                {this.props.streetView}
              </div>)
    }
  }
  render() {
    return (
      <>
      {this.slidePanel()}
      <div className="dot-pane">
        <PanelDots selected={this.state.slideIndex} count={this.slideMax} onClick={this.slide}/>        
      </div>
       </>
    )
  }
}
